import { ChockPage } from "./ChockPage";

const Chock = () => {
	return <ChockPage />;
};
export default Chock;
